module.exports = __webpack_public_path__ + "img/horizontal_4_6_8017.e35f1c3b.png";